import React, {  Suspense } from 'react';
import AppRouter from "./AppRouter";
import UserStore from "./tools/UserStore";


function AppPage() {

    return (       
        <UserStore>
            <AppRouter />
        </UserStore>
    );
}

// loading component for suspense fallback
const Loader = () => (
    <div className="App">
        <div>loading...</div>
    </div>
);

// here app catches the suspense from page in case translations are not yet loaded
export default function App() {
    return (
        <Suspense fallback={<Loader />}>
            <AppPage />
        </Suspense>
    );
}


